import { AlertTriangle, RefreshCw } from 'lucide-react'
import { getCorrelationId, getErrorMessage } from '@/shared/lib/errors'

interface ErrorStateProps {
  /** Short, human-readable summary of what failed. */
  title?: string
  /** The caught error. Its message is shown beneath the title when available. */
  error?: unknown
  onRetry?: () => void
  compact?: boolean
}

/** The single approved "the request failed" presentation. */
export default function ErrorState({
  title = 'Something went wrong.',
  error,
  onRetry,
  compact = false,
}: ErrorStateProps) {
  const detail = getErrorMessage(error)
  const correlationId = getCorrelationId(error)

  return (
    <div
      role="alert"
      className={`flex flex-col items-center justify-center gap-2 px-6 text-center ${
        compact ? 'h-40' : 'h-64'
      }`}
    >
      <AlertTriangle size={compact ? 18 : 22} className="text-red-500" />
      <p className="text-sm font-medium text-red-600">{title}</p>
      {detail && <p className="max-w-md text-xs text-gray-500">{detail}</p>}
      {correlationId && (
        <p className="font-mono text-[11px] text-gray-400 select-all">ID {correlationId}</p>
      )}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 inline-flex items-center gap-1.5 rounded border border-gray-300 px-3 py-1 text-xs font-medium text-gray-600 transition-colors hover:border-gray-400 hover:text-gray-800"
        >
          <RefreshCw size={12} />
          Try again
        </button>
      )}
    </div>
  )
}
